import { useEffect, useState } from "react";

/**
 * Fallback "invisível" para Suspense de rotas.
 * Só mostra o spinner se o chunk demorar mais de 250ms para carregar,
 * evitando o flash de loading em navegações rápidas.
 */
const SuspenseFallback = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 250);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="h-8 w-8 rounded-full border-2 border-muted border-t-primary animate-spin" />
    </div>
  );
};

export default SuspenseFallback;
